const styles = theme => ({
  root: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: theme.palette.primary.main,
    height: "25%",
    "@supports (padding-top: constant(safe-area-inset-top))": {
      "--safe-area-inset-top": "constant(safe-area-inset-top)",
      height: "calc(25% + var(--safe-area-inset-top))",
      paddingTop: "var(--safe-area-inset-top)"
    },
    "@supports (padding-top: env(safe-area-inset-top))": {
      "--safe-area-inset-top": "env(safe-area-inset-top)",
      height: "calc(25% + var(--safe-area-inset-top))",
      paddingTop: "var(--safe-area-inset-top)"
    }
  },
  rootLogin: {
    [theme.breakpoints.up("lg")]: {
      background: theme.palette.secondary.light
    }
  },
  point: {
    position: "absolute",
    left: "36%",
    bottom: -10,
    width: 20,
    height: 20,
    background: theme.palette.primary.main,
    transform: "rotate(45deg)",
    [theme.breakpoints.down("md")]: {
      left: "30%"
    },
    [theme.breakpoints.down("ms")]: {
      left: "15%"
    }
  },
  pointLogin: {
    [theme.breakpoints.up("lg")]: {
      display: "none"
    }
  },
  logo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    paddingTop: 10,
    paddingBottom: 10
  },
  logoLogin: {
    [theme.breakpoints.up("lg")]: {
      height: "auto"
    }
  },
  image: {
    maxHeight: "100%"
  },
  imageLogin: {
    [theme.breakpoints.up("lg")]: {
      width: "200px",
      height: "200px",
      objectFit: "contain"
    },
    [theme.breakpoints.down("md")]: {
      width: "100px",
      height: "100px",
      objectFit: "contain"
    }
  },
  avatar: {
    avatar: {
      marginLeft: theme.spacing(2),
      background: theme.palette.primary.main
    }
  },
  whiteLabeledLogo: {
    borderRadius: "50%",
    [theme.breakpoints.up("lg")]: {
      width: "200px",
      height: "200px",
      objectFit: "contain"
    },
    [theme.breakpoints.down("md")]: {
      width: "100px",
      height: "100px",
      objectFit: "contain"
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(4)
    }
  },
  orgName: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      color: "white"
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(1),
      fontSize: "20px"
    }
  },
  headerText: {
    display: "none",
    padding: theme.spacing(3),
    maxWidth: 600,
    textAlign: "center"
  },
  headerTextLogin: {
    [theme.breakpoints.up("lg")]: {
      display: "block"
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Header/styles.js